import { useMemo } from 'react';
import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const useBasicCopilotDepartmentsAndLocations = ({
  dropdownOptions,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
}) => {
  return useMemo(() => {
    return {
      departments: dropdownOptions
        .filter((dropdownOption) => dropdownOption.dropdownId === 'department')
        .map((dropdownOption) => dropdownOption.dropdownItemValue),
      locations: dropdownOptions
        .filter((dropdownOption) => dropdownOption.dropdownId === 'location')
        .map((dropdownOption) => dropdownOption.dropdownItemValue),
    };
  }, [dropdownOptions]);
};
